var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 98,
    viewBox: "0 0 97 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3781_13560)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 15,
    width: 60,
    height: 60,
    rx: 30,
    fill: "black",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.25,
    y: 13.75,
    width: 62.5,
    height: 62.5,
    rx: 31.25,
    stroke: "white",
    strokeWidth: 2.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1542 43.09C37.6525 43.09 37.2559 42.6933 37.2559 42.1917V39.4967C37.2559 36.335 39.8342 33.7567 42.9959 33.7567H45.6909C46.1925 33.7567 46.5892 34.1533 46.5892 34.655C46.5892 35.1567 46.1925 35.5533 45.6909 35.5533H42.9959C40.8142 35.5533 39.0525 37.3267 39.0525 39.4967V42.1917C39.0525 42.6933 38.6442 43.09 38.1542 43.09Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6909 43.09C59.2009 43.09 58.7925 42.6933 58.7925 42.1917V39.4967C58.7925 37.315 57.0192 35.5533 54.8492 35.5533H52.1542C51.6525 35.5533 51.2559 35.145 51.2559 34.655C51.2559 34.165 51.6525 33.7567 52.1542 33.7567H54.8492C58.0109 33.7567 60.5892 36.335 60.5892 39.4967V42.1917C60.5892 42.6933 60.1925 43.09 59.6909 43.09Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8496 57.0901H53.2279C52.7379 57.0901 52.3296 56.6934 52.3296 56.1917C52.3296 55.7017 52.7263 55.2934 53.2279 55.2934H54.8496C57.0313 55.2934 58.7929 53.5201 58.7929 51.3501V49.7401C58.7929 49.2501 59.1896 48.8417 59.6913 48.8417C60.1813 48.8417 60.5896 49.2384 60.5896 49.7401V51.3501C60.5896 54.5117 58.0113 57.0901 54.8496 57.0901Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6909 57.0902H42.9959C39.8342 57.0902 37.2559 54.5118 37.2559 51.3502V48.6552C37.2559 48.1535 37.6525 47.7568 38.1542 47.7568C38.6559 47.7568 39.0525 48.1535 39.0525 48.6552V51.3502C39.0525 53.5318 40.8259 55.2935 42.9959 55.2935H45.6909C46.1809 55.2935 46.5892 55.6902 46.5892 56.1918C46.5892 56.6935 46.1925 57.0902 45.6909 57.0902Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4595 44.5251H54.8728H42.9728H41.3861C40.8845 44.5251 40.4878 44.9335 40.4878 45.4235C40.4878 45.9135 40.8845 46.3218 41.3861 46.3218H42.9728H54.8728H56.4595C56.9611 46.3218 57.3578 45.9135 57.3578 45.4235C57.3578 44.9335 56.9611 44.5251 56.4595 44.5251Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9727 47.6868V48.0718C42.9727 50.0085 44.536 51.5718 46.4727 51.5718H51.3727C53.3093 51.5718 54.8727 50.0085 54.8727 48.0718V47.6868C54.8727 47.5468 54.7677 47.4418 54.6277 47.4418H43.2177C43.0777 47.4418 42.9727 47.5468 42.9727 47.6868Z",
    fill: "#FAFAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9727 43.16V42.775C42.9727 40.8383 44.536 39.275 46.4727 39.275H51.3727C53.3093 39.275 54.8727 40.8383 54.8727 42.775V43.16C54.8727 43.3 54.7677 43.405 54.6277 43.405H43.2177C43.0777 43.405 42.9727 43.3 42.9727 43.16Z",
    fill: "#FAFAFB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3781_13560",
    x: 0,
    y: 0.5,
    width: 97,
    height: 97,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.384444 0 0 0 0 0.494535 0 0 0 0 0.720833 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3781_13560"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3781_13560",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanner);
export default __webpack_public_path__ + "static/media/scanner.d8076b41f4a16eb51e324a32e092772a.svg";
export { ForwardRef as ReactComponent };